<template>
    <button
        type="button"
        class="a-keyboard-key keyboard-key"
        :aria-label="`${ariaLabel}${item}`"
        @click="onClick(item)"
    >
        <slot>
            {{ item }}
        </slot>
    </button>
</template>

<script>
export default {
    name: 'OKeyboardKey',
    props: {
        item: {
            type: String,
            default: ''
        },
        ariaLabel: {
            type: String,
            default: 'Keyboard key -'
        }
    },
    methods: {
        onClick(e) {
            this.$emit('onClick', e);
        }
    }
}
</script>

<style lang="scss">
@import "a-keyboard-key";
</style>
